import { render, staticRenderFns } from "./MerchView.vue?vue&type=template&id=4dbb5f23&"
import script from "./MerchView.vue?vue&type=script&lang=js&"
export * from "./MerchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports